"use client";
import { jsx as c } from "react/jsx-runtime";
const h = () => /* @__PURE__ */ c(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    focusable: "false",
    height: "100%",
    width: "100%",
    children: /* @__PURE__ */ c("path", { d: "M10 1.5c.556 0 1.052.16 1.49.478.437.319.732.726.885 1.222h3.458c.459 0 .851.166 1.177.5.327.332.49.732.49 1.2v11.9c0 .467-.163.868-.49 1.2a1.59 1.59 0 0 1-1.177.5H4.167A1.59 1.59 0 0 1 2.99 18a1.654 1.654 0 0 1-.49-1.2V4.9c0-.468.163-.868.49-1.2a1.59 1.59 0 0 1 1.177-.5h3.479c.153-.496.451-.903.896-1.222.444-.319.93-.478 1.458-.478ZM5.833 4.9H4.167v11.9h11.666V4.9h-1.666v.85c0 .468-.163.868-.49 1.2a1.59 1.59 0 0 1-1.177.5h-5a1.59 1.59 0 0 1-1.177-.5 1.654 1.654 0 0 1-.49-1.2V4.9ZM10 3.2a.798.798 0 0 0-.594.244.83.83 0 0 0-.24.606c0 .24.08.443.24.606.16.163.358.244.594.244a.798.798 0 0 0 .594-.244.83.83 0 0 0 .24-.606.83.83 0 0 0-.24-.606A.798.798 0 0 0 10 3.2Z" })
  }
);
export {
  h as IconPaste
};
